import { CARS } from '../../shared/cars.js';
import type { CarSpec } from '../../shared/types.js';
import { escapeHtml, safeColour } from '../ui/html.js';
import { t } from '../i18n/index.js';

export interface GarageStepModel {
  car: CarSpec;
  paint: string;
  carInfoHtml: string;
  tuningHtml: string;
  locked: boolean;
  /** Kicker above the car name, e.g. the wizard step or "IN-LOBBY GARAGE". */
  eyebrow: string;
}

export function garageStepHtml(model: GarageStepModel): string {
  const index = CARS.findIndex((car) => car.id === model.car.id);
  return `
    <div class="garage-step">
      <section class="garage-showroom" aria-label="${t('Selected vehicle')}">
        <p class="eyebrow garage-eyebrow">${escapeHtml(model.eyebrow)}</p>
        <div class="garage-carousel">
          <button type="button" class="garage-cycle" data-car-cycle="-1" aria-label="${t('Previous vehicle')}" ${model.locked ? 'disabled' : ''}>‹</button>
          <div class="car-tabs" role="listbox" aria-label="${t('Vehicles')}" data-pad-tabs>
            ${CARS.map((car, carIndex) => `<button type="button" role="option" data-car="${car.id}" class="${car.id === model.car.id ? 'active' : ''}" aria-selected="${car.id === model.car.id}" ${model.locked ? `disabled title="${t('Leave the ghost challenge to change vehicle')}"` : ''}><b>${String(carIndex + 1).padStart(2, '0')}</b><span>${escapeHtml(car.name)}</span><small>${escapeHtml(t(car.className))}</small></button>`).join('')}
          </div>
          <button type="button" class="garage-cycle" data-car-cycle="1" aria-label="${t('Next vehicle')}" ${model.locked ? 'disabled' : ''}>›</button>
        </div>
        <div class="garage-preview" id="garage-preview" style="--car-paint:${safeColour(model.paint)}"><span class="preview-label">${garageNamePlateHtml(model.car)}</span><span class="preview-hint" aria-hidden="true">${t('⟲ DRAG TO ROTATE')}</span></div>
        <p class="garage-counter"><b>${String(index + 1).padStart(2, '0')}</b> / ${String(CARS.length).padStart(2, '0')} · ${t('← → TO BROWSE')}</p>
      </section>
      <section class="garage-workshop" aria-label="${t('Tuning')}">
        <div class="car-info" id="car-info">${model.carInfoHtml}</div>
        <div class="tuning-grid" id="tuning-grid">${model.tuningHtml}</div>
      </section>
    </div>`;
}

/** Name plate laid over the showroom stage; shared with live car switching. */
export function garageNamePlateHtml(car: CarSpec): string {
  const index = CARS.findIndex((entry) => entry.id === car.id);
  return `<small>${String(index + 1).padStart(2, '0')} // ${escapeHtml(t(car.className))}</small><b>${escapeHtml(car.name)}</b>`;
}
